import { PaysafeFormField } from './paysafe-form-field.enum';

export interface PaysafeFieldConfig {
  accessibilityLabel: string;
  fieldName: PaysafeFormField;
  optional?: boolean;
  placeholder: string;
  selector: string;
}
